import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type AiRecommendationModel from './ai-recommendation';

export default class EvaluationModel extends Model {
  @attr declare actorDecision: string;
  @attr declare agreement: string;
  @attr declare recommendationOutcome: string;
  @attr declare evaluationMetadata: Record<string, unknown>;
  @attr declare recommendableType: string;
  @attr declare recommendableId: string;
  @attr declare actorType: string;
  @attr declare actorId: string;
  @attr declare initiatorType: string;
  @attr declare initiatorId: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @belongsTo('ai-recommendation', { async: false, inverse: null })
  declare aiRecommendation: AiRecommendationModel | null;

  get agreementLabel() {
    return this.agreement?.replace('EvaluationAgreement.', '') ?? '';
  }

  get isAgreed() {
    return this.agreement === 'EvaluationAgreement.AGREED';
  }

  get isDisagreed() {
    return this.agreement === 'EvaluationAgreement.DISAGREED';
  }

  get hasNoRecommendation() {
    return this.agreement === 'EvaluationAgreement.NO_RECOMMENDATION';
  }

  get agreementIntent() {
    if (this.isAgreed) return 'success';
    if (this.isDisagreed) return 'danger';
    return 'default';
  }

  [Type] = 'evaluation' as const;
}
